export enum Controls {
  label = 'Label',
  checkbox = 'CheckBox',
  title = 'Title',
  icon = 'Icon',
}
